import { render, staticRenderFns } from "./invoiceRecord.pug?vue&type=template&id=54ac9f06&scoped=true&lang=pug&"
import script from "./invoiceRecord.ts?vue&type=script&lang=ts&"
export * from "./invoiceRecord.ts?vue&type=script&lang=ts&"
import style0 from "./invoiceRecord.styl?vue&type=style&index=0&id=54ac9f06&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac9f06",
  null
  
)

export default component.exports